import { Component, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-full-text',
  templateUrl: './full-text.component.html',
  styleUrls: ['./full-text.component.scss'],
  standalone: false,
})
export class FullTextComponent {
  private route = inject(ActivatedRoute);

  protected trademarkFieldTopList: any;
  public fulltext = '';
  public trademarkName = '';
  constructor() {
    this.fulltext = this.route.snapshot.data.fullText;
    this.modifyFullTextContents();
    const doc = this.convertFullTextToHTML();
    this.trademarkName = this.getTrademarkName(doc);
    this.trademarkFieldTopList = [
      { field: 'Publication Date', value: this.getPublicationDate(doc) },
      { field: 'Filing Status', value: this.getFilingStatus(doc) },
      { field: 'Registration Date', value: this.getRegistrationDate(doc) },
      { field: 'Trademark Nr.', value: this.getTrademarkNumber(doc) },
    ];
  }

  public convertFullTextToHTML(): Document {
    const parser = new DOMParser();
    return parser.parseFromString(this.fulltext, 'text/html');
  }
  getTrademarkName(document: Document): string {
    return this.getHTMLSectionValueById(document, '#trademarkCol');
  }
  getTrademarkNumber(document: Document): string {
    return this.getHTMLSectionValueById(document, '#trademarkNo');
  }
  getFilingStatus(document: Document): string {
    return this.getHTMLSectionValueById(document, '#filingStatus');
  }
  getPublicationDate(document: Document): string {
    return this.getHTMLSectionValueById(document, '#publicationDateCol');
  }
  getRegistrationDate(document: Document): string {
    return this.getHTMLSectionValueById(document, '#registrationDateCol');
  }
  getHTMLSectionValueById(document: Document, id: string): string {
    const section = document.body.querySelector(id);
    if (section !== null) {
      const result = section.getElementsByTagName('p')[0].innerText;
      return result.trim().length === 0 ? '--' : result;
    } else {
      return '--';
    }
  }

  public modifyFullTextContents(): void {
    this.fulltext = this.fulltext.replace('Class(es) Reported', 'Classes');
    this.fulltext =
      this.fulltext.slice(0, 43) +
      '<label>Logo</label>' +
      this.fulltext.slice(43);
  }
}
